import { render, staticRenderFns } from "./Trends.vue?vue&type=template&id=5de2e395&"
import script from "./Trends.vue?vue&type=script&lang=js&"
export * from "./Trends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LRGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de2e395')) {
      api.createRecord('5de2e395', component.options)
    } else {
      api.reload('5de2e395', component.options)
    }
    module.hot.accept("./Trends.vue?vue&type=template&id=5de2e395&", function () {
      api.rerender('5de2e395', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/trends/Trends.vue"
export default component.exports